import React from 'react'
import styled, { useTheme } from 'styled-components/native'
import I18n from 'APP/I18n'
import Button from 'APP/Converse/Button'
import Typography from 'APP/Converse/Typography'
import WHOLogo from 'APP/Images/who-logo.svg'

const BannerContainer = styled.View`
  align-items: center;
  gap: ${({ theme }) => theme.metrics.baseMargin / 2}px
  margin:${({ theme }) => theme.metrics.baseMargin * 2}px;
  padding: ${({ theme }) => theme.metrics.baseMargin * 1.5}px;
  border-radius: ${({ theme }) => theme.metrics.baseMargin / 2}px;
  background-color: ${({ theme }) => theme.colors.bannerBg};
`

const WHOBanner = ({ onCtaPress }: { onCtaPress?: () => void }) => {
  const theme = useTheme()

  return (
    <BannerContainer testID="WHO_BANNER">
      <WHOLogo fill={theme.colors.text} />
      <Typography variant="bodyNormal">
        {I18n.t('RecentActiveHistoryScreen.whoBanner.copy')}
      </Typography>
      <Button
        variant="secondary"
        widthVariant="full"
        onPress={onCtaPress}
        analyticsName="Find out more"
        testID="FIND_OUT_MORE_BTN"
        title={I18n.t('RecentActiveHistoryScreen.whoBanner.cta')}
      />
    </BannerContainer>
  )
}

export default WHOBanner
